/**
 * One route for every quote-first owner screen (lists, details, editors, plus the
 * dashboard, first run, settings, payments and templates), so the admin layout stays mounted between them.
 * Lives in its own file so the entry bundle can import it without pulling icons or screens.
 */
export const OWNER_AREA_PATH = /^\/admin\/(quotes|invoices|clients|requests|jobs|schedule|equipment|dashboard|onboarding|settings|payments|reports|templates|change-orders)(\/.*)?$/;

/** The part of the owner area an estimator may enter: their own requests and quotes and the clients on them. The server is the guard; this only keeps them off screens that would show nothing but 403s. */
export const ESTIMATOR_PATHS = /^\/admin\/(requests|quotes|clients)(\/.*)?$/;

/** Roles admitted to an owner-area path: admins and staff everywhere, estimators only on ESTIMATOR_PATHS. */
export function ownerAreaRoles(pathname: string): Array<'admin' | 'staff' | 'estimator'> {
  return ESTIMATOR_PATHS.test(pathname) ? ['admin', 'staff', 'estimator'] : ['admin', 'staff'];
}
